export default __webpack_public_path__ + "static/media/RunPanda.071edf65.svg";